import { render, staticRenderFns } from "./Group.vue?vue&type=template&id=6ba8fab8&scoped=true"
import script from "./Group.vue?vue&type=script&lang=js"
export * from "./Group.vue?vue&type=script&lang=js"
import style0 from "./Group.vue?vue&type=style&index=0&id=6ba8fab8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba8fab8",
  null
  
)

export default component.exports